import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../../components/Loader';
import { fetchInvoice } from '../../actions';
import { selectInvoice } from '../../selectors';
import { selectWork } from '../../../Api/selectors';
import { REQUEST_INVOICE } from '../../constants';
import { VBox } from '../../../../components/Box';
import { performAction } from '../../../KanbanBoards/actions';
import { FormField } from '../../../../components/FormFields';
import { DeleteInvoiceModal } from '../DeleteInvoiceModal';
import { Button } from '../../../../components/Buttons';

const Container = styled.div`
  position: relative;

  box1 {
    h2 {
      font-size: 16px;
      text-transform: uppercase;
    }
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class DeleteInvoiceComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchInvoice(result => {});
  }

  componentDidUpdate(prevProps, prevState) {}

  get showDeleteButton() {
    return !this.props.invoice?.isFinal;
  }

  showDeleteModal() {
    this.setState({ showDeleteModal: true });
  }
  onConfirmDeleteModal() {
    this.setState({ showDeleteModal: false }, this.props.deleteInvoice);
  }

  onCancelDeleteModal() {
    this.setState({ showDeleteModal: false });
  }

  renderDeleteSection() {
    if (this.showDeleteButton)
      return (
        <VBox>
          <FormField>
            <Button className={this.props.className} warning={true} onClick={this.showDeleteModal.bind(this)}>
              {this.lbl('invoice.details.deleteBtn')}
            </Button>
          </FormField>
          {this.renderDeleteModal()}
        </VBox>
      );

    return '';
  }

  renderDeleteModal() {
    return (
      this.state.showDeleteModal && (
        <DeleteInvoiceModal
          onConfirm={this.onConfirmDeleteModal.bind(this)}
          onCancel={this.onCancelDeleteModal.bind(this)}
        />
      )
    );
  }

  render() {
    if (this.props.workInvoice) return <Loader small />;
    const invoice = this.props.invoice;
    return (
      <Container innerWidth={window.innerWidth}>
        <VBox right style={{ maxWidth: 225 }}>
          {this.renderDeleteSection()}
        </VBox>
      </Container>
    );
  }
}

DeleteInvoiceComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(ownProps.invoiceId),
    workInvoice: selectWork(REQUEST_INVOICE),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchInvoice(callback) {
      dispatch(fetchInvoice(ownProps.invoiceId, callback));
    },
    confirm(callback) {
      dispatch(
        performAction(
          ownProps.action?.id,
          ownProps.vehicle?.id,
          { regplate_code: ownProps.vehicle?.regplate_code || '' },
          callback,
        ),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const DeleteInvoice = compose(withConnect, withRouter)(DeleteInvoiceComp);
